import { useNavigate, useParams } from "react-router-dom";
import { ScrollArea } from "@/core/components/ui/scroll-area";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { NewReportControls } from "@/profitability/new-report-controls";
import { profitabilityRunPath } from "@/profitability/routes";
import { RunDetail } from "@/profitability/run-detail";
import { RunList } from "@/profitability/run-list";
export const ProfitabilityContent = ({
  businessId,
}: {
  businessId: string;
}) => {
  const { runId } = useParams();
  const navigate = useNavigate();
  const openRun = (id: string) => navigate(profitabilityRunPath(id));

  if (runId)
    return (
      <Stack
        fullWidth
        gap="none"
        className="mx-auto flex h-[calc(100vh-4rem)] max-w-[1680px] flex-col px-8 pb-6"
      >
        <RunDetail key={runId} businessId={businessId} runId={runId} />
      </Stack>
    );

  return (
    <ScrollArea className="h-[calc(100vh-4rem)]">
      <Stack fullWidth className="mx-auto max-w-[1680px] px-8 pb-8">
        <Stack
          direction="row"
          align="center"
          justify="between"
          gap="sm"
          fullWidth
          className="flex-wrap gap-y-2 py-4"
        >
          <Stack gap="none" className="min-w-0">
            <Typography variant="titleW3">Profitability</Typography>
            <Typography variant="bodyW3" textColor="secondary">
              Build a report for any range of dates.
            </Typography>
          </Stack>
          <NewReportControls businessId={businessId} onCreated={openRun} />
        </Stack>
        <RunList businessId={businessId} onOpenRun={openRun} />
      </Stack>
    </ScrollArea>
  );
};
